import { useState } from 'react';
import type { CascadeWarning } from '../../types/canvas';

interface CascadeBadgeProps {
  warnings: CascadeWarning[];
  onDismiss?: () => void;
}

export function CascadeBadge({ warnings, onDismiss }: CascadeBadgeProps) {
  const [showPopover, setShowPopover] = useState(false);

  if (warnings.length === 0) return null;

  return (
    <div className="relative inline-flex">
      <button
        onClick={() => setShowPopover(!showPopover)}
        className="w-2 h-2 rounded-full bg-primary shadow-[0_0_0_3px_rgba(194,65,12,0.12)] cursor-pointer border-none p-0 flex-shrink-0"
        aria-label={`${warnings.length} cascade warning${warnings.length > 1 ? 's' : ''}`}
      />
      {showPopover && (
        <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 z-50 w-64 bg-background border border-border rounded-lg shadow-lg p-3">
          <div className="text-[10px] font-semibold uppercase tracking-wider text-placeholder mb-2">
            May need review
          </div>
          <ul className="space-y-1.5">
            {warnings.map((w, i) => (
              <li key={i} className="text-xs text-muted-foreground leading-relaxed">
                {w.reason}
              </li>
            ))}
          </ul>
          <div className="flex gap-2 mt-3 pt-2 border-t border-border">
            {onDismiss && (
              <button
                onClick={() => { onDismiss(); setShowPopover(false); }}
                className="text-[10px] font-medium text-primary cursor-pointer border-none bg-transparent"
              >
                Dismiss
              </button>
            )}
            <button
              onClick={() => setShowPopover(false)}
              className="text-[10px] font-medium text-muted-foreground cursor-pointer border-none bg-transparent ml-auto"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
